<template>
  
  <div class="link-box">
    <ButtonComponent url="https://www.galstian-furniture.com" variant="primary">Website<img src="../assets/home-button-white-icon.svg" class="icon"></ButtonComponent>
    <ButtonComponent url="https://www.instagram.com/galstianfurniture" variant="primary">Instagram<img src="../assets/instagram-white-icon.svg" class="icon"></ButtonComponent>
    <ButtonComponent url="https://wa.me/+982188740199" variant="primary">Whatsapp<img src="../assets/whatsapp-white-icon.svg" class="icon"></ButtonComponent>
    <ButtonComponent url="https://www.linkedin.com/company/galstian-furniture" variant="primary">Linkedin<img src="../assets/linkedin-app-white-icon.svg" class="icon"></ButtonComponent>
    <ButtonComponent url="https://g.co/kgs/HJ8qqj6" variant="primary">Address<img src="..//assets/pin-location-icon.svg" class="icon"></ButtonComponent>
  </div>
  <div class="langChange">
    <button>En</button>
    <button>فا</button>
  </div>
</template>

<script>
import ButtonComponent from './ButtonComponent.vue';

export default {
  components: {
    ButtonComponent,
  },
};
</script>

<style scoped>
.link-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  padding:1em; /* More reasonable padding */
  border-radius: 10px; /* Correct syntax */
}
.link-box .icon {
  width: 6%;
  height: auto;
  padding-inline-start: 25%;
 
}
.link-box .icon:hover {
  width: 12%;
  height: auto;
  background:none;
  background-color: transparent;
}

.langChange {
  display:inline;
  padding-top: 2em;
  padding-bottom: 1em;
  font-size: 2em;
  border-radius: 1em;
  gap: 2em;
}

</style>
